import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { updateJiraMappingsInTemplateAction } from '../actions';
import { updateJiraMappingInTemplate } from '../slices';
function* updateJiraMappingsInTemplateSaga(action) {
    try {
        const { payload: { taskId, data } } = action;
        yield put(updateJiraMappingInTemplate({
            taskId,
            data
        }));
    } catch (error) {
        message.error('There was an error on updating jira config', error);
    }
}
export function* watchUpdateJiraMappingsInTemplateSaga() {
    yield takeLatest(updateJiraMappingsInTemplateAction.type, updateJiraMappingsInTemplateSaga);
}
